export default {

    data:()=>({
        active: false,
        isLoading: false,
        btnLoading: false,
        server_errors: {
            name: '',
            email: '',
            password: '',
            roleId: '',
            branchId: '',
        },
        users: {
            name: '',
            email: '',
            password: '',
            user_tel: '',
        },

        roleId: [],
        permissions: [],
        provincesId: [],

        branches: [],
        selectedBranch: {},
        displayCheckbox: false,
        option: false

    }), // Data

    methods:{

        ShowPermission(){
            this.$axios.get('show-permission-roles',{
                params:{
                    roleId: this.roleId
                }
            }).then(res=>{
                this.permissions = res.data;
            });
        }, // Show-Permissions

        ValidateForm(){
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.SaveItem();
                }
            });
        }, // ValidateForm

        SaveItem(){
            this.btnLoading = true;
            this.users.roleId = this.roleId;
            this.users.provincesId = this.provincesId;
            this.users.branchId = this.selectedBranch.id;
            this.users.option = this.option;
            this.$axios.post('register-branch-users', this.users).then(res=>{
                if(res.data.success == true){
                    setTimeout(() => {
                        this.btnLoading = false;
                        this.$emit('close');
                        this.$emit('success');
                        this.$notification.OpenNotification_AddItem_OnSuccess('top-right', 'dark', 3000);
                    }, 300);
                }
            }).catch(error=>{
                this.btnLoading = false;
                if(error.response.status == 422){
                    var obj = error.response.data.errors;
                    for (let [key, value] of Object.entries(obj)) {
                        this.server_errors[key] = value[0];
                    }
                }
            });
        }, // Register User

        FetchData(){
            this.isLoading = true;
            this.$axios.get('list/all/branches').then(res=>{
                setTimeout(()=>{
                    this.isLoading = false;
                    this.branches = res.data.listBranches;
                    this.selectedBranch = {...this.branches[0]};
                }, 100);
            }).catch(()=>{});
        },

        FilterBranch(){
            if(this.selectedBranch.distribution_center_id !== null){
                this.displayCheckbox = true;
            }else{
                this.displayCheckbox = false;
                this.option = false;
            }
        }
    },

    watch: {
        'selectedBranch': function(){
            this.FilterBranch();
        },
        'users.userCardid': function () {
            this.server_errors.userCardid = '';
        },
        'users.name':function(){
            this.server_errors.name = '';
        },
        'users.email':function(){
            this.server_errors.email = '';
        },
        'users.password':function(){
            this.server_errors.password = '';
        },
        'roleId':function(){
            this.server_errors.roleId = '';
        }
    },
}
